import { NODE_TYPE } from '@/lib/nodeType';

/*
    Настройка параметров для получения массива ID месторождений.
    См: api description

    TODO: Если будет усложняться, переписать.
*/

export const settingParamsForFieldsRequest = calculationObject => {
    const { id, parentVentureId, node } = calculationObject;

    if (node === NODE_TYPE.LICENSE) {
        return {
            licenseId: id,
            ventureId: parentVentureId, // ТПП ID
        };
    }

    return {
        parentVentureId: parentVentureId || id,
        ventureId: parentVentureId ? id : null,
    };
};
